<div class="content-box">
  <section class="todas-noticias" aria-labelledby="todas-noticias-titulo">
    <app-breadcrumb pagina="Notícias"></app-breadcrumb>

    <div class="todas-noticias-layout">
      <app-noticia-destaque></app-noticia-destaque>

      <div class="todas-noticias-principal">
        <div class="todas-noticias-cabecalho">
          <span class="todas-noticias-etiqueta">Notícias</span>

          <h1 class="todas-noticias-pagina-titulo" id="todas-noticias-titulo">
            Confira todas as notícias
          </h1>
        </div>

        <div class="todas-noticias-controles mt-5">
          <div class="todas-noticias-filtros" role="group" aria-label="Filtrar notícias por categoria">
            @for (filtro of filtros(); track filtro.id) {
              <button
                type="button"
                class="todas-noticias-filtro"
                [class.todas-noticias-filtro-ativo]="categoriaAtiva() === filtro.id"
                [style.--todas-noticias-filtro-cor]="filtro.cor"
                [attr.aria-pressed]="categoriaAtiva() === filtro.id"
                (click)="selecionarCategoria(filtro.id)"
              >
                <span class="todas-noticias-filtro-ponto" aria-hidden="true"></span>
                {{ filtro.rotulo }}
              </button>
            }
          </div>

          <div class="todas-noticias-busca">
            <i-lucide
              class="todas-noticias-busca-icone"
              name="search"
              size="18"
              aria-hidden="true"
            ></i-lucide>

            <label class="todas-noticias-busca-label" for="todas-noticias-busca">
              Buscar notícia
            </label>
            <input
              id="todas-noticias-busca"
              class="todas-noticias-busca-input"
              type="search"
              autocomplete="off"
              placeholder="Buscar notícias"
              [value]="termoBusca()"
              (input)="aoBuscar($event)"
            />

            @if (termoBusca()) {
              <button
                type="button"
                class="todas-noticias-busca-limpar"
                aria-label="Limpar busca"
                (click)="limparBusca()"
              >
                <i-lucide name="x" size="16" aria-hidden="true"></i-lucide>
              </button>
            }
          </div>
        </div>

        <p #listaNoticias class="todas-noticias-resultado" role="status">
          {{ totalResultados() }}
          {{ totalResultados() === 1 ? 'notícia encontrada' : 'notícias encontradas' }}
        </p>

        @if (noticiasDaPagina().length) {
          <div class="todas-noticias-grade">
            @for (noticia of noticiasDaPagina(); track noticia.id) {
              <app-noticia-card [noticia]="noticia"></app-noticia-card>
            }

            <app-links-dinamicos local="Notícias" [exibir]="paginaAtual() === 1"></app-links-dinamicos>
          </div>
        } @else if (!carregando()) {
          <div class="todas-noticias-vazio">
            <p class="todas-noticias-vazio-texto">
              Nenhuma notícia encontrada para a busca ou o filtro selecionado.
            </p>

            @if (temFiltroAtivo()) {
              <button type="button" class="todas-noticias-vazio-botao" (click)="limparTudo()">
                Limpar busca e filtros
              </button>
            }
          </div>
        }

        @if (totalPaginas() > 1) {
          <app-paginacao
            rotulo="Paginação das notícias"
            [paginaAtual]="paginaAtual()"
            [totalPaginas]="totalPaginas()"
            (paginaMudou)="irParaPagina($event)"
          ></app-paginacao>
        }
      </div>
    </div>
  </section>
</div>
